import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useRateStudySet = ({ id }: { id: string }) => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return useMutation(
    trpc.studysets.upsertRating.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.getById.queryKey({ id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.getUserRating.queryKey({ id }),
        });
        toast.success("Study Set successfully rated");
      },
      onError: () => {
        toast.error("Failed to rate Study Set");
      },
    }),
  );
};
